export const tabConfig = {
  loads: {
    value: 'loads',
    label: 'Lasten',
  },
  certificates: {
    value: 'certificates',
    label: 'Nachweise',
  },
  models: {
    value: 'models',
    label: 'Modelle',
  },
  dxf: {
    value: 'dxf',
    label: 'DXF',
  },
}
